import { NUMBER_TYPE } from '@/utils/constants';

export default {
  subTextSetNumber: 'Digita el número móvil, linea fija o contrato de Claro Hogar',
  app: 'https://play.google.com/store/apps/details?id=com.recarga.saldo1.claro.ni.app',
  profiles: [
    {
      key: NUMBER_TYPE[1],
      checkboxLabel: 'Móvil',
      inputLabel: 'Digita tu número telefónico'
    },
    {
      key: NUMBER_TYPE[2],
      checkboxLabel: 'Línea Fija',
      inputLabel: 'Digita tu número telefónico'
    },
    {
      key: NUMBER_TYPE[0],
      checkboxLabel: 'Contrato',
      inputLabel: 'Digita tu número de contrato'
    }
  ]
};
